import { postChat, getLimitsChat, getHistoryThreads, getHistoryMessages, postFeedback, postThumbs } from "./backend";

type User = { id?: string; role?: string; plan?: string };

async function testChat(user?: User) {
  console.log("[calcera:debug] testChat → /api/chat");
  const res = await postChat({ message: "hello", category: "TECH" }, user);
  console.log("[calcera:debug] chat result:", res);
  return res;
}

async function testLimits(user?: User) {
  console.log("[calcera:debug] testLimits → /api/limits/chat");
  const res = await getLimitsChat(user);
  console.log("[calcera:debug] limits:", res);
  return res;
}

async function testHistory(user?: User) {
  console.log("[calcera:debug] testHistory → /api/history/threads + messages");
  const th = await getHistoryThreads({ limit: 5 }, user);
  console.log("[calcera:debug] threads:", th);
  const first = th.threads?.[0]?.id;
  if (first) {
    const ms = await getHistoryMessages({ threadId: first, limit: 10 }, user);
    console.log("[calcera:debug] messages:", ms);
    return { th, ms };
  }
  return { th, ms: null } as any;
}

async function testFeedback(user?: User) {
  console.log("[calcera:debug] testFeedback → /api/feedback");
  const res = await postFeedback({ message: "Great app!" }, user);
  console.log("[calcera:debug] feedback:", res);
  return res;
}

async function testThumbs(user?: User, vote: "up" | "down" = "up", prompt = "Thumbs quick test") {
  console.log("[calcera:debug] testThumbs → /api/thumbs", vote);
  const userId = user?.id;
  const res = await postThumbs({ vote, prompt, userId }, user);
  if (!res.ok) {
    console.error("[calcera:thumbs:error]", { status: res.status, debug: res.debug, body: res.body, data: res.data });
  } else {
    // If the backend returns { data, error }, surface it
    const data = res.data;
    if (data && (data.error || data.errors)) {
      console.warn("[calcera:thumbs:resend-warning]", data.error || data.errors);
    }
    console.log("[calcera:thumbs]", res.debug || "ok", data);
  }
  return res;
}

function attach() {
  const g: any = globalThis as any;
  g.CalceraDebug = {
    testChat,
    testLimits,
    testHistory,
    testFeedback,
    testThumbs,
  };
  console.log("[calcera:debug] window.CalceraDebug attached (use .testChat(), .testLimits(), .testHistory(), .testFeedback(), .testThumbs())");
}

attach();


